import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: '[sklGridTemplate]' })
export class GridTemplateDirective<T> {
    @Input('sklGridTemplate') public name!: string;

    public constructor(
        public template: TemplateRef<T>,
    ) {}
}
